import './MetasDepartamentos.css'
import { useEffect, useRef, useState } from 'react';
import { logout } from '../../auth';
import { get, post } from '../../services/api';
import AdminSection from "../AdminSection/AdminSection";
import imagemExemplo from '../../assets/img/imagemExemploCsvDpto.png';
import DownloadIcon from '@mui/icons-material/Download';

export default function MetasDepartamentos({ setNotifier }) {

    const [ valorBase, setValorBase ] = useState('');
    const [ valorBaseCSVFileName, setValorBaseCSVFileName ] = useState(undefined);
    const [ valorBasePadrao, setValorBasePadrao ] = useState(0);
    const valorBaseCSVRef = useRef(undefined);
    const valorBasePadraoRef = useRef(undefined);
    const [ departmentos, setDepartmentos ] = useState([
        '1. Linha Branca','2. Linha Marrom','3. Telef. Celular','4. Móveis','5. Colchões','6. Portáteis','7. Informática','8. Esportes e lazer',
        '9. Utilidades','10. Cama, mesa e banho','11. Linha alta','12. Linha automotiva',
    ]); 

    function handleRefresh(e, type = 'all') {
        e.preventDefault();

        refreshInputs(type);
    }

    function isThirdStagePopuled() {
        const valorBaseNumber = Number(valorBase.replaceAll('.', '').replace(',', '.'))

        return  (!isNaN(valorBaseNumber) && valorBaseNumber != 0) ||
            valorBaseCSVFileName !== undefined || 
                valorBasePadrao !== 0;  
    }

    function refreshInputs(type = 'all') {
        setValorBase('');
        setValorBaseCSVFileName(undefined);
        if(valorBaseCSVRef.current?.value != undefined) valorBaseCSVRef.current.value = null;
        setValorBasePadrao(0);
        if(valorBasePadraoRef.current?.value != undefined) valorBasePadraoRef.current.checked = false;
    }

    async function handleValorBaseSubmit(event){
        event.preventDefault();

        const idUsuarioAtual = localStorage.getItem("idusuario");
        const authToken = localStorage.getItem("adminToken");

        if(typeof idUsuarioAtual === 'undefined') {
            logout();
        } else{
            const formData = new FormData(event.target);

            formData.append('idusuario', idUsuarioAtual);

            const { response } = await post('/admin/painelbordo/metas-departamentos', formData, authToken, { 
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            
            if(response?.status >= 400){
                setNotifier(false, response.data)
            }
            else{
                setNotifier(true, 'Enviado com sucesso')
            }
        }
    }

    function baixarExemploCSV() {
        const csvData = [
            ['Cod. Filial', 'Mes', 'Ano', 'Meta ideal', 'Meta desafio', 'Meta orcada', 'Cod. Departamento'],
        ];

        const csvContent = csvData.map(e => e.join(";")).join("\n");
        const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'exemploDepartamento.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return <>
    <AdminSection
        etapa={1} titulo={'Exemplo a ser seguido:'} 
        acoes={<>
            <button className='download-btn' onClick={baixarExemploCSV}> <DownloadIcon style={{width: '25px', height: '25px', marginRight: '10px'}}/> Exportar modelo</button>
        </>}
    >
        <div className='imagemExemplo'> 
            <img src={imagemExemplo} alt="Exemplo" /><br></br>
        </div>  
    </AdminSection>
    <AdminSection
        etapa={2} titulo={'Departamentos exemplo:'}
    >
        <div className='departmento-list'>
            {departmentos.map((departmento, index) => (
                <div key={index} className='departmento-item'>
                    {departmento}
                </div>
            ))}
        </div>
    </AdminSection>
    <AdminSection
        etapa={3} titulo={'Importar o CSV'}
    >
        <form onSubmit={handleValorBaseSubmit}>
            <div className='p-8'>
                <div style={{textAlign: 'center', marginBottom: '15px'}}>O arquivo deve ser em formato CSV(Separado por virgulas).</div>
                <div className='valorBaseCSV-wrapper'>
                    <label htmlFor="valorBaseCSV" className={valorBase != '' || valorBasePadrao !== 0 ? 'disabled' : ''}>{valorBaseCSVFileName === undefined ? 'Importar CSV' : valorBaseCSVFileName}</label>
                        <input type="file" accept='.csv' ref={valorBaseCSVRef} name='valorBaseCSV' id="valorBaseCSV" onChange={(e) => {
                            const uploadedFile = e.target.files[0];
                            if (uploadedFile) {
                                setValorBaseCSVFileName(uploadedFile.name);
                            }
                        }} disabled={valorBase != '' || valorBasePadrao !== 0}/>
                    <div className='animal-valorBase-buttons'>
                        <button 
                            className='animal-refresh-btn' 
                            onClick={(e) => handleRefresh(e, 'metaBase')}>Limpar</button>
                        
                        <button className='animal-save-btn' disabled={!isThirdStagePopuled()}>Enviar CSV</button>
                    </div>
                </div>
            </div>
        </form>
    </AdminSection>
</>
}